import api from 'api';

import { defaultPagination } from './general';

export const listRegionals = async (params) => api().get('/regionals', { params: { ...defaultPagination, ...params } });

export const getRegionals = async ({ id }) => api().get(`regionals/${id}`);

export const createRegionals = async ({ data }) => api().post('regionals', data);

export const updateRegionals = async ({ id, data }) => api().put(`regionals/${id}`, data);
